import { render, staticRenderFns } from "./ProductGalleryZoomCarousel.vue?vue&type=template&id=38bbebd6&scoped=true&"
import script from "./ProductGalleryZoomCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryZoomCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleryZoomCarousel.vue?vue&type=style&index=0&id=38bbebd6&lang=scss&scoped=true&"
import style1 from "./ProductGalleryZoomCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbebd6",
  null
  
)

export default component.exports